function initMissionPartner(root) {
  if (!root || root.dataset.mpInit) return;
  root.dataset.mpInit = 'true';

  var targets = root.querySelectorAll('.fade-in-up');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.section-mission-partner').forEach(initMissionPartner);
});

document.addEventListener('shopify:section:load', function (event) {
  var root = event.target.querySelector('.section-mission-partner');
  if (root) initMissionPartner(root);
});